<a role="link" tabindex="0" (click)="navSupport()" (keyup.enter)="navSupport">Contact Us</a>
<p>{{email}}</p>